import { render, staticRenderFns } from "./bartop.vue?vue&type=template&id=45cb9f56&scoped=true&"
import script from "./bartop.vue?vue&type=script&lang=js&"
export * from "./bartop.vue?vue&type=script&lang=js&"
import style0 from "./bartop.vue?vue&type=style&index=0&id=45cb9f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb9f56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/baikaifa/Desktop/codes/baikaifa-overwrite-skeleton-webpack-plugin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45cb9f56')) {
      api.createRecord('45cb9f56', component.options)
    } else {
      api.reload('45cb9f56', component.options)
    }
    module.hot.accept("./bartop.vue?vue&type=template&id=45cb9f56&scoped=true&", function () {
      api.rerender('45cb9f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "preview/components/bartop.vue"
export default component.exports